// extracted by mini-css-extract-plugin
module.exports = {"stepsNav":"Service_stepsNav__2B00l","navLink":"Service_navLink__1VF2n","active":"Service_active__25qcw"};